<div class="shipping-container ">

  <!-- Original card (title + summary rows). Clicking anywhere here toggles the
       timeline. The expanded timeline below is intentionally OUTSIDE this wrapper
       so that clicking the timeline does not collapse the card. -->
  <div class="card-toggle" (click)="shippingContainer.expanded=!shippingContainer.expanded">

    <!-- Title row -->
    <div class="d-flex ps-4 py-2 title-row show-bottom-border">
      <div class="brand-alpha">
        <svg class="me-3" width="36" height="36">
          <use href="/assets/icons.svg#shipping-container"></use>
        </svg>
      </div>

      <div class="label me-4 pt-2">{{shippingContainer.equipmentNumber}}</div>
      <div class="value pt-2">{{shippingContainer.containerDescription}}</div>
    </div>


    <!-- Summary row -->
    <div class="d-flex p-4 summary-row flex-column flex-md-row"
         [class.show-bottom-border]="shippingContainer.expanded">
      <div class="d-flex flex-grow-1 pb-4 pb-md-0" *ngIf="eta">
        <div class="brand-alpha">
          <svg class="me-3" width="36" height="36">
            <use href="/assets/icons.svg#calendar"></use>
          </svg>
        </div>

        <div class="flex-grow-1 d-flex flex-column">
          <div class="label">Estimated arrival date</div>
          <div class="value">{{eta | date:'dd MMMM yyyy HH:mm'}}</div>
        </div>
      </div>


      <div class="d-flex flex-grow-1 pb-4 pb-md-0" *ngIf="shippingContainer.lastLocation">
        <div class="brand-alpha">
          <svg class="me-3" width="36" height="36">
            <use href="/assets/icons.svg#location"></use>
          </svg>
        </div>

        <div class="flex-grow-1 d-flex flex-column">
          <div class="label">Last location</div>
          <div class="value">{{shippingContainer.lastLocation}}</div>
        </div>
      </div>


      <!-- Visual affordance only; the whole card above handles the click. -->
      <div class="show-details pt-2 text-center text-md-end">
        <div *ngIf="!shippingContainer.expanded" class="text-nowrap ps-3">
          <span>Show details</span>
          <svg class="ms-2" width="16" height="16">
            <use href="/assets/icons.svg#down-arrow"></use>
          </svg>
        </div>

        <div *ngIf="shippingContainer.expanded" class="text-nowrap ps-3">
          <span>Hide details</span>
          <svg class="ms-2" width="16" height="16">
            <use href="/assets/icons.svg#up-arrow"></use>
          </svg>
        </div>
      </div>
    </div>
  </div>


  <!-- Timeline details -->
  <div class="pt-5 background-white" *ngIf="shippingContainer.expanded">
    <app-timeline [events]="shippingContainer.sourceEvents"></app-timeline>
  </div>
</div>
